<template>
  <div class="home-index" v-show="!loading">
    <RouterView />
    <div class="footer">
      <div class="copy container">
        <!-- 版权所有 -->
        <p style="font-size: 14px; margin-top: 5px;">&copy; 2026 青蛙计划。保留所有权利。</p>

        <!-- 个人网站的可选补充：友情免责 -->
        <p style="font-size: 14px; margin-top: 5px;">
          本站内容仅供学习交流，如有侵权请联系删除。
        </p>
        <p style="font-size: 14px; margin-top: 5px;">
          <!-- <a href="https://beian.mps.gov.cn/" target="_blank">
            <img src="#" alt="公安备案图标">
            公安备案号
          </a> -->
          <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2023038551号-5</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { provide, ref } from 'vue'

export default {
  name: 'HomeIndex',
  setup () {
    const loading = ref(true)
    const doneLoading = () => {
      loading.value = false
    }
    provide('doneLoading', doneLoading)
    return {
      loading
    }
  }
}
</script>

<style lang="less" scoped>
.home-index {
  // scrollbar-color: rgb(226, 226, 226) ;
  background-color: rgb(226, 226, 226);
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
}

.footer {
  height: 200px;
  // width: 100vh;
  // background-color: antiquewhite;
  background-color: rgb(255, 255, 255);
  padding: 20px 20px;
  .copy {
    margin: auto auto;
  }
  @media (max-width: 768px) {
    height: 150px;
  }
}

</style>>
